import { createAction } from '@reduxjs/toolkit';

export const setFirstName = createAction('StepSmartName/set/firstName');
export const setLastName = createAction('StepSmartName/set/lastName');
export const setMiddleName = createAction('StepSmartName/set/middleName');
